//custom.js
$(function() {
  $('[data-toggle="tooltip"]').tooltip();

  $(function() {
    $('[data-toggle="popover"]').popover();
  })
})
